import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import RazorpayCheckout from './components/RazorpayCheckout';
import ThankYou from './components/ThankYou';
import PaymentFailed from './components/PaymentFailed';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:userId/:planId" element={<RazorpayCheckout />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
        </Routes>
      </Router>
    </div>

  );

}

export default App;
